import { useSelector } from "react-redux";
import { MulticotizadorState } from "../types";

interface MulticotizadorRootState {
  multicotizadorReducer: MulticotizadorState;
}

/**
 * Lectura tipada de `multicotizadorReducer`. Todos los pasos leen del mismo
 * reducer, así que el tipo del estado se declara una sola vez acá en lugar de
 * repetirlo en cada paso.
 */
const useMulticotizadorSelector = <T>(
  selector: (state: MulticotizadorState) => T
): T =>
  useSelector<MulticotizadorRootState, T>((state) =>
    selector(state.multicotizadorReducer)
  );

export default useMulticotizadorSelector;
